import { ClientEvents, LoginModalDismissElements } from 'common/events/ClientEvents';
import { isNil } from 'lodash';
import { useEffect } from 'react';
import { useNativeAppMessenger } from 'src/mobile-app/NativeAppMessengerContext';
import { ModalAnimation } from 'src/shared/design-system/Modal/utils';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { useTracker } from 'src/shared/hooks/useTracker';
import { Modal, ModalType } from 'web-common/src/shared/design-system/components/Modal';
// Once Native-bridge is fixed, we can remove these.
import { createReqRes } from '@shef/native-bridge/dist/src/request-handler/createReqRes';
import { genericStatusMessage } from '@shef/native-bridge/src/schemas/util/basic';
import * as t from 'io-ts';
import { LoginOrSignUpModalContent } from './LoginOrSignUpModalContent';
import { useShowLoginOrSignUpModal } from './useShowLoginOrSignUpModal';

// @jonathan needs npm logins to publish native-bridge, so this is a hack for now
// must be the same as the one in shef-web
export const loginModalShown = createReqRes('loginModalShown', t.type({}), genericStatusMessage);

interface LoginOrSignUpModalProps {
  hide: () => void;
  isShowing: boolean;
  animation?: ModalAnimation;
}

export const LoginOrSignUpModal: React.FC<LoginOrSignUpModalProps> = ({ isShowing, hide }) => {
  const [currentUser, currentUserIsLoading] = useCurrentUser();
  const tracker = useTracker();
  const { isClosable } = useShowLoginOrSignUpModal();
  const { signUpEntryPoint } = useShowLoginOrSignUpModal();

  const nativeAppMessenger = useNativeAppMessenger();

  useEffect(() => {
    if (isShowing) {
      tracker.track(ClientEvents.LOGIN_MODAL_OPENED, { signUpEntryPoint });
      // Send message to native app when login modal is shown
      if (nativeAppMessenger && !currentUser) {
        try {
          nativeAppMessenger.sendRequest(loginModalShown, {}).catch((error) => {
            console.error('Failed to send loginModalShown event to native app', error);
          });
        } catch (e) {
          console.error('Failed to send loginModalShown event to native app', e);
        }
      }
    }
  }, [isShowing, tracker, signUpEntryPoint, nativeAppMessenger]);

  const handleClose = (element: LoginModalDismissElements) => {
    hide();
    tracker.track(ClientEvents.LOGIN_MODAL_DISMISSED, { signUpEntryPoint, element });
  };

  return (
    <Modal isShowing={isShowing && !currentUserIsLoading && isNil(currentUser)} modalType={ModalType.PEEK_A_BOO}>
      <div className='max-h-screen overflow-y-auto'>
        <LoginOrSignUpModalContent showClose={isClosable} onCloseButtonClicked={handleClose} stickyHeader />
      </div>
    </Modal>
  );
};
